<template>
  <div class="cart-container">
    <el-table
      ref="cartList"
      :data="cartList"
      :row-class-name="getRowClass"
      style="width: 100%"
      empty-text="购物车里还是空的"
      @selection-change="onSelectionChange"
    >
      <el-table-column :selectable="checkRowSelectable" type="selection" width="50" align="center" />
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <div class="cart-item-image">
            <div v-if="scope.row.activityFlag" class="cart-activity-item">
              <img src="@/assets/images/activity/activity-icon.png">
            </div>
            <img :src="getImageUrl(scope.row.itemImageUri)" >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template slot-scope="scope">
          <span class="cart-item-name">{{ scope.row.itemName }}</span>
          <span v-if="scope.row.publishStatus === 1 && scope.row.isPreOrder === 1" class="pre-sale">(预售)</span>
          <span v-if="scope.row.publishStatus !== 1" class="un-publish">(已下架)</span>
        </template>
      </el-table-column>
      <el-table-column label="可售数量" width="110">
        <template slot-scope="scope">
          <span v-if="scope.row.isPreOrder !== 1" class="available-qty">{{ scope.row.availableQty || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单价" width="120">
        <template slot-scope="scope">￥ {{ getItemSalePrice(scope.row) | toThousandslsFilter }}</template>
      </el-table-column>
      <el-table-column label="数量" width="160">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.itemQty"
            :min="scope.row.minQty"
            :max="scope.row.maxQty"
            :step="scope.row.stepQty"
            size="mini"
            @change="onQtyChange(scope.row)"
          />
          <div v-if="scope.row.stepQty > 1" class="font-12">仅支持以{{ scope.row.stepQty }}倍数量购买</div>
        </template>
      </el-table-column>
      <el-table-column label="小计" width="160">
        <template slot-scope="scope">
          <span class="row-summary">￥ {{ getRowSummary(scope.row) | toThousandslsFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeCartItem(scope.row, scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="coolerGiftQty !== null" class="cooler-gift__qty">
      <div class="cooler-gift__qty--img">
        <img src="@/assets/images/activity/activity-img.png">
      </div>
      <div>当前赠品剩余数量：{{ coolerGiftQty | toThousandslsFilter }}</div>
    </div>
    <el-row class="button-line">
      <el-col :span="3" :offset="1">
        <el-button type="default" size="small" class="btn-red" @click="removeBatch">删除选中商品</el-button>
      </el-col>
      <el-col :span="10">
        <span class="total-amount">已选择 {{ totalCount | toThousandslsFilter }} 件商品，共计 ￥{{ totalAmount | toThousandslsFilter }} 元</span>
      </el-col>
      <el-col :span="10" class="text-right">
        <el-button class="btn-cancel" @click="backToItemList">取 消</el-button>
        <el-button :loading="loading" class="btn-settle" @click="doSettlement">结 算</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const math = require("mathjs")
import { commonUtils } from '@/utils/common'

export default {
  name: 'CartView',
  props: {
    cartList: {
      type: Array,
      default: () => []
    },
    coolerGiftQty: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      itemSelection: [],
      loading: false,
    }
  },
  computed: {
    totalCount () {
      let total = 0
      this.itemSelection.map(item => {
        total = math.add(total, item.itemQty)
      })
      return commonUtils.formatNumber(total)
    },
    totalAmount () {
      let total = 0
      this.itemSelection.map(item => {
        const salePrice = item.promotionPrice && item.promotionPrice > 0 ? item.promotionPrice : item.itemPrice
        const rowSum = math.multiply(item.itemQty, salePrice)
        total = math.add(total, rowSum)
      })
      return Number(commonUtils.formatNumber(total).toFixed(2))
    },
  },
  mounted () {
    
  },
  methods: {
    onSelectionChange (val) {
      this.itemSelection = val
    },
    getRowClass ({ row }) {
      if (row.publishStatus !== 1) {
        return 'warning-row'
      }
      if (row.isPreOrder !== 1 && row.availableQty < row.minQty) {
        return 'warning-row'
      }
      if (row.itemQty % row.stepQty !== 0) {
        return 'warning-row'
      }
      return ''
    },
    checkRowSelectable (row) {
      if (row.publishStatus !== 1) {
        return false
      }
      if (row.isPreOrder !== 1 && row.availableQty < row.minQty) {
        return false
      }
      return true
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    getItemSalePrice (item) {
      return item.promotionPrice && item.promotionPrice > 0 ? item.promotionPrice : item.itemPrice
    },
    onQtyChange (item) {
      if (item.itemQty % item.stepQty !== 0) {
        this.$message.error('购买数量应为订购倍数的整数倍')
        return
      }
      this.$store.dispatch('UpdateCartItem', item)
    },
    getRowSummary (item) {
      const salePrice = item.promotionPrice && item.promotionPrice > 0 ? item.promotionPrice : item.itemPrice
      const summaryVal = math.multiply(item.itemQty, salePrice)
      return commonUtils.formatNumber(summaryVal)
    },
    removeCartItem (row) {
      // console.log(index)
      const removeItems = []
      removeItems.push(row)
      this.$store.dispatch('RemoveCartItems', removeItems).then(() => {
        this.$emit('remove')
      })
    },
    removeBatch () {
      if (this.itemSelection.length === 0) {
        this.$message.error('请选择要删除的商品')
        return
      }
      this.$store.dispatch('RemoveCartItems', this.itemSelection).then(() => {
        this.itemSelection = []
        this.$emit('remove')
      })
    },
    backToItemList () {
      this.$router.push('/item/list')
    },

    // 结算时的筛选
    doSettlement () {
      if (this.itemSelection.length === 0) {
        this.$message.error('还未选择要结算的商品')
        return
      }
      // let flag = this.itemSelection[0].isPreOrder
      const settleItems = []
      let activityItemCount = 0

      for (const i in this.itemSelection) {
        const item = this.itemSelection[i]

        //活动专区商品的数量
        if (item.itemBrandList[0].abiBrandCode === 'HARBINActivity') {
          activityItemCount++
        }

        // if (item.isPreOrder !== flag) {
        //   this.$message.error('预售商品和现货商品不能同时下单')
        //   return
        // }
        if (item.publishStatus !== 1) {
          this.$message.error('商品【' + item.itemName + '】已下架')
          return
        }
        if (item.isPreOrder !== 1 && item.availableQty < item.minQty) {
          this.$message.error('商品【' + item.itemName + '】库存不足')
          return
        }
        if (item.itemQty % item.stepQty !== 0) {
          this.$message.error('商品【' + item.itemName + '】购买数量不是订购倍数的整数倍')
          return
        }
        settleItems.push({
          itemId: item.itemId,
          selected: 1
        })
      }

      // 活动专区商品不能和普通商品一起下单
      if (activityItemCount != 0 && this.itemSelection.length > 1 && activityItemCount < this.itemSelection.length) {
        this.$message.error('活动专区商品和普通商品不能同时下单')
        return
      }

      this.loading = true
      this.$store.dispatch('SettleCartItems', settleItems).then(() => {
        this.loading = false
        this.$router.push('/order/confirm')
      }).catch(() => {
        this.loading = false
        this.$message.error('提交结算异常')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/variables.scss';
.cart-container {
  .cart-item-image {
    width: 70px;
    height: 70px;
    overflow: hidden;
    margin: 5px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  /deep/ .el-table .warning-row {
    background: #fbc4c4;
  }
  .pre-sale {
    color: green;
    margin-left: 10px;
  }
  .el-input-number--mini {
    width: 120px;
  }
  .el-input-number--mini .el-input__inner {
    padding-left: 10px;
    padding-right: 10px;
  }
  .available-qty {
    margin-left: 10px;
    color: green;
  }
  .un-publish {
    margin-left: 10px;
    color: red;
  }
  .row-summary {
    color: $base-yellow;
  }
  .button-line {
    height: 60px;
    line-height: 60px;
    background-color: #eee;
  }
  .btn-remove-batch {
    &:hover,
    &:active,
    &::after {
      background-color: $base-red;
      color: #fff;
    }
    &:focus {
      background-color: $base-red;
      color: #fff;
      outline: none;
      border: 0px;
    }
  }
  .total-amount {
    color: $base-yellow;
  }
  .btn-cancel {
    height: 60px;
    width: 120px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    border: 0;
    border-radius: 0;
    background-color: #cdcdcd;
    &:focus {
      outline: none;
      border: 0px;
    }
  }
  .btn-settle {
    height: 60px;
    width: 160px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    border: 0;
    border-radius: 0;
    background-color: #f47820;
    margin-left: 0px;
    &:focus {
      outline: none;
      border: 0px;
    }
  }
}

.cooler-gift__qty {
  color: $base-yellow;
  padding: 15px 30px;
  display: flex;
  align-items: bottom;
  div:nth-child(2) {
    padding: 4px 14px;
    padding-top: 9px;
  }
  &--img {
    img {
      width: 468.75px;
      height: 30px;
    }
  }
}

.cart-activity-item {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 27px;
  height: 34.5px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
